module.exports = __webpack_public_path__ + "static/img/tu5.d0c03d1c.png";